export enum PAGE_TYPE {
  PRODUCT = 'Product',
  SEARCH = 'search',
  WISHLIST = 'wishlist',
  NOT_FOUND = '404',
  TRACKING = 'tracking',
  LANDING_PAGE = 'LandingPage',
  OUR_VALUES = 'our values',
  ABOUT_US = 'about us',
  SUSTAINABILITY = 'sustainability',
  HOW_IT_WORKS = 'how it works',
  FACTORIES = 'factories',
  CONTACT_US = 'contact us',
  CART = 'cart',
}

export enum TRACK_PAGE_TYPE {
  HOME = 'Home Page',
  PDP = 'Product Page',
  COLLECTION = 'Collection Page',
  SEARCH = 'Search Page',
  CART = 'Cart Page',
  LANDING_PAGE = 'Landing Page',
  NOT_FOUND = '404 Page',
  WISHLIST = 'Wishlist Page',
  PARTNER_PDP_LANDING_PAGE = 'Partner PDP Landing Page',
  AUTHENTICATION = 'Authentication Page',
  ACCOUNT = 'Account Pages',
  REVIEW_IMAGE_UPLOAD = 'Review Image Upload',
  CAREERS = 'Careers Page',
}

export enum PAGE_VARIANT {
  MINI_PDP = 'Mini Product Page',
}
